import { useMemo, useState } from "react";
import { isWordMatchingSearch } from "@utils/string-utils";
import { TemplateItem } from "@domain/template/template";

export function useTemplateFilters(templates: TemplateItem[]): {
	setSearch: (search: string) => void;
	templateTotalCount: number;
	filteredTemplates: TemplateItem[];
} {
	const [search, setSearch] = useState("");
	const templateTotalCount = useMemo(() => templates.length, [templates]);

	const filteredTemplates = useMemo(
		() => (search ? templates.filter(template => isWordMatchingSearch(template.name, search)) : templates),
		[search, templates],
	);

	return { setSearch, templateTotalCount, filteredTemplates };
}
